module.exports = __webpack_public_path__ + "img/esrb-teen-rating.6289724c.svg";